import { useAuth0 } from '@auth0/auth0-react';
import get from 'lodash/get';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AuthModule, CLIENT_TYPE } from '@numbox/modules';
import { testIsAuth0Token } from '@numbox/util';

import CenteredSpinner from '@shared/CenteredSpinner';

import { userLoggedIn } from '~/util/auth';
import { urlWithSearch } from '~/util/router';

import { LoginContext } from './LoginContext';
import { useNumaAuth0 } from './auth0Util';
import { getSafeDestination } from './constants';

export const CheckAuth = () => {
  const history = useHistory();
  const { attemptSilentAuth0Login } = useNumaAuth0();
  const { loginWithRedirect } = useAuth0();

  const location = useLocation();
  const desiredDestination = urlWithSearch(
    get(location, 'state.from.pathname', ''),
    get(location, 'state.from.search', ''),
  );

  const { setDesiredDestination } = useContext(LoginContext);

  const dispatch = useDispatch();

  useEffect(() => {
    setDesiredDestination(desiredDestination);
    const cookieToken = userLoggedIn();
    const isAuth0Token = testIsAuth0Token(cookieToken);

    const redirectToAuth0 = () => {
      let redirectUri;
      if (
        typeof desiredDestination === 'string' &&
        !desiredDestination.includes('code=')
      ) {
        redirectUri = `/login/auth0redirect?redirectTo=${encodeURIComponent(
          desiredDestination,
        )}`;
      } else {
        // If the redirect url includes code=, that is from previous Auth0 login attempts
        // so we dont need to use it to redirect, send them to the inbox.
        redirectUri = '/login/auth0redirect';
      }

      loginWithRedirect({
        authorizationParams: {
          prompt: 'login',
          redirect_uri: `${window.location.origin}${redirectUri}`,
        },
        appState: {
          redirectUri,
        },
      });
    };

    if (!isAuth0Token && cookieToken) {
      dispatch(
        AuthModule.refreshToken.request(
          {
            refreshToken: cookieToken,
            clientType: CLIENT_TYPE,
          },
          {
            onSuccess: () => {
              history.push(getSafeDestination(desiredDestination));
            },
            onFailure: () => {
              redirectToAuth0();
            },
          },
        ),
      );
    } else {
      attemptSilentAuth0Login({
        onSuccess: () => {
          history.push(getSafeDestination(desiredDestination));
        },
        onFailure: () => {
          redirectToAuth0();
        },
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <CenteredSpinner />;
};
